type MeterProps = {
  /** 0..1 */
  value: number;
  /** optional target band, both 0..1 */
  targetMin?: number;
  targetMax?: number;
  height?: number | string;
  label?: string;
};

/** Ballistic VU-style vertical meter. Fed by live mic RMS or a timed drill's progress. */
export function Meter({ value, targetMin, targetMax, height = 200, label = "Level" }: MeterProps) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <div
      class="meter"
      style={{ height }}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
    >
      {targetMin !== undefined && targetMax !== undefined && (
        <div
          class="meter-target"
          style={{ bottom: `${targetMin * 100}%`, height: `${(targetMax - targetMin) * 100}%` }}
        />
      )}
      <div class="meter-fill" style={{ height: `${pct}%` }} />
    </div>
  );
}
